import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import {
  CursorPaginatedResponse,
  SmartSheet,
  unwrapSmartTableCursorCollectionPayload,
} from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface UseListSheetsOptions {
  cursor?: string | null;
  limit?: number;
}

export const useListSheets = (
  tableId?: string,
  { cursor = null, limit = 100 }: UseListSheetsOptions = {},
) => {
  const userToken = useAuth()?.userToken ?? "";
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const wid = Number(workspaceId);

  return useQuery<CursorPaginatedResponse<SmartSheet>>({
    queryKey: ["smart-tables", wid, tableId, "sheets", cursor, limit],
    queryFn: async () => {
      const url = new URL(ENDPOINTS.smart_table_sheets(wid, tableId!));
      url.searchParams.set("limit", String(limit));
      if (cursor) {
        url.searchParams.set("cursor", cursor);
      }
      const response = await fetch(url.toString(), {
        headers: jsonAuthHeaders(userToken),
      });
      const payload = await handleResponse(response);
      return unwrapSmartTableCursorCollectionPayload<SmartSheet>(payload, "sheets");
    },
    enabled: !!workspaceId && !!tableId,
  });
};
